<template lang="html">
<div class="home">
  <div class="testThings">
    <p>－测肤注意事项－</p>
    <ul>
      <li>检查细致到毛孔, 务必使用<span>后置摄像头</span></li>
      <li>点击<span>开始按钮</span>, 拍照时请打开<span>闪光灯</span></li>
      <li>按手机音量<span>减键拍摄</span>, 拍照记得要<span>闭眼</span>哦</li>
    </ul>
    <!-- <img src="./img/copy@2x.png"> -->
  </div>
  <div class="photoDetail">
    <img src="./img/photo@2x.png" alt="拍照详细细节" @click="getDetail"/>
  </div>
  <div class="start">
    <div class="start-test">
      <input type="file" id="getPhoto" accept="image/*" capture="camera" style="display: none;" @change="handleFile"/>
      <img class="c2h4-button__begin" id="photoTrigger" @click="handleBegin" :src="!!agreementState.check ? agreementState.startTest : agreementState.unstartTest" />
    </div>
    <div class="c2h4-div__user__agreement">
      <div class="c2h4-div__user__check" @click="handleAgreement">
        <img :src="!!agreementState.check ? agreementState.agreeIcon : agreementState.unagreeIcon" alt="用户协议" />
        <a class="c2h4-a__user__agreement" href="https://api.c2h4.org/agreement/">同意:《你今天真好看用户服务协议》</a>
      </div>
    </div>
  </div>
  <div id="wrap"></div>
</div>
</template>

<script>
import agreeIcon from './img/agreement.png'
import unagreeIcon from './img/unagreement.png'
import startTest from './img/startTest.png'
import unstartTest from './img/unstartTest.png'

export default {
  methods: {
    handleAgreement () {
      this.agreementState.check = !this.agreementState.check
    },
    handleBegin () {
      this.clickCount++
      const input = document.getElementById('getPhoto')
      const event = new MouseEvent('click', {
        'view': window,
        'bubbles': false,
        'cancelable': true
      })
      console.log('send')
      window.BD_MMS_SKILL.sendLog()
      if (this.agreementState.check) {
        let triggerEvent = input.dispatchEvent(event)
        if (!triggerEvent) {
          alert('请更换浏览器重试')
        }
      }
    },
    handleFile (e) {
      if (e.target.files[0]) {
        this.$store.dispatch({
          type: 'storePhoto',
          photo: e.target.files[0]
        })
        this.$router.push('/upload')
      }
    },
    getDetail () {
      this.$router.push('/course')
    }
  },
  data () {
    return {
      clickCount: 0,
      agreementState: {
        check: true,
        agreeIcon: agreeIcon,
        unagreeIcon: unagreeIcon,
        startTest: startTest,
        unstartTest: unstartTest
      }
    }
  }
}
</script>

<style scoped>
home {
  width: 100%;
}
.testThings {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  margin-top:3.73vw;
  margin-bottom: 6.13vw
}
.testThings > p {
  font-size: 4.8vw;
  font-weight: 600;
  letter-spacing: 1.5px;
  color: #64c8c8;
}
.testThings > ul {
  font-size: 4.2vw;
  line-height: 3;
  letter-spacing: 0.5px;
}
.testThings span {
  font-weight: 600;
}
/* .testThings > img {
  width: 82.4vw;
  height: 39.73vw;
} */

.photoDetail {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 40.27vw;
  margin-bottom: 3.73vw;
}
.photoDetail > img {
  width: 82.4vw;
  height: 40.27vw;
  margin-left: 8.8vw;
  margin-right: 8.8vw;
}
/*开始拍照部分*/
.start {
  width: 100vw;
  height: 67.2vw;
  background-image: url(./img/startBg@2x.png);
  background-repeat: no-repeat;
  background-size: cover;
}
.c2h4-div__user__agreement{
  text-align: center;
  padding-top: 6.67vw;
  padding-bottom: 10.4vw;
}
.c2h4-a__user__agreement{
  text-decoration: none;
  color: #646464;
}
.c2h4-div__user__check{
  font-size: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}
.c2h4-div__user__check img{
  display: inline-block;
  width:3.73333333vw;
  height: 3.733333333vw;
  vertical-align: top;
  padding-right: 2vw;
}
.c2h4-div__user__check a {
  display: inline-block;
  font-size: 3.2vw;
}
.start-test {
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 7.2vw;
}
.c2h4-button__begin{
  width: 38.4vw;
  height: 38.4vw;
  color: #fff;
  /*-webkit-transform: rotate(-45deg); */
}
/*
.start-content {
  position: relative;
  display:flex;
  justify-content: center;
  align-items:center;
  width: 100vw;
  padding: 5vw 0;
  box-sizing: border-box;
}
.circle-wrapper{
  width: 38.4vw;
  height: 38.4vw;
  position: relative;
  border-radius: 50%;
  border: 2vw solid #64c8c8;
  -webkit-transform: rotate(45deg);
  display:flex;
  justify-content: center;
  align-items:center;
}*/
</style>



// WEBPACK FOOTER //
// src/components/Home/index.vue